import React, { useState, useEffect } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';

const UpdateItemGridGRN = ({ onRequisitionData, itemData, grnData, selectedPOData, currencyPrecision, isVatExcluded, setIsVatExcluded,
    setOverallDiscount, grandTotal, overallDiscount, setDiscountAmount, discountAmount, setGrandTotal, setVatAmount, vatAmount, }) => {
    const apiService = new ApiService();

    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        qty: '',
        uom: '',
        vatDes: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        convValue: '',
        vatAmount: '',
        expDate: null,
        balQty: "",
        batchNo: "",
        inventoryAccountCode: "",
        inventoryAccountName: "",
    }]);

    const calculatedTotal = rows.reduce((sum, row) => {
        const qty = parseFloat(row?.qty) || 0;
        const unitPrice = parseFloat(row?.baseAmount) || 0;
        let final = (unitPrice * qty)
        return sum + (final);
    }, 0);

    useEffect(() => {
        const getItems = async () => {
            try {
                const apiService = new ApiService();
                let param = `?POrderNo=View?POrderNo=View&GRNNo=${grnData?.grnNo}&Mode=2`
                const PO = await apiService.getApiParamater("GET_PO_ITEM_UPDATE", param);
                const formattedRowsitm = PO?.data?.result?.map(async (detail, index) => {
                    const selecteditms = await apiService.getApiParamater("GET_ITEM", `?ItemNo=${detail.itemCode}`);
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", `?ItemNo=${detail.itemCode}`);
                    const selectedGrnItem = PO.data.result?.find(rec => rec.itemDescription === detail.itemDescription)
                    let glAccount = getGLAccounts?.data?.result[0] || ""
                    let itm = selecteditms?.data?.result[0]

                    const amount = Number(detail?.qty || 0) * Number(detail?.unitPrice || 0);

                    const discountPerc = Number(overallDiscount || 0);

                    const discountAmount = (amount * discountPerc) / 100;

                    const calculatedAmount = amount - discountAmount;

                    const vatRate = Number(detail?.vatPerc || 0);

                    const vatAmount = (calculatedAmount * vatRate) / 100;

                    const totalAmount = calculatedAmount + vatAmount;

                    return {
                        requisitionNo: detail.requisitionNo,
                        srno: detail?.srno,
                        ItemNo: detail.itemCode,
                        qty: detail.qty,
                        itemDescription: detail.itemDescription,
                        uom: detail.uom,
                        baseQty: itm.convToInvUOM * detail.qty,
                        baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
                        vatDes: detail.vatDesc,
                        convValue: itm.convToInvUOM,
                        freeQty: detail?.extraQty || 0,
                        specification: detail ? detail.specification : '',
                        balQty: selectedGrnItem?.balQty,
                        expDate: detail?.expDate,
                        batchNo: detail?.batchNo,
                        inventoryAccountCode: glAccount.inventoryAccountCode,
                        inventoryAccountName: glAccount.inventoryAccountName,
                        GRNAccountName: glAccount.grnAccountName,
                        GRNAccountCode: glAccount.grnAccountCode,

                        discount: discountPerc,
                        discountAmount: Number(discountAmount).toFixed(currencyPrecision),
                        calculatedAmount: Number(calculatedAmount).toFixed(currencyPrecision),
                        vat: vatRate,
                        vatAmount: Number(vatAmount).toFixed(currencyPrecision),
                        amount: Number(totalAmount).toFixed(currencyPrecision),
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsitm);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        if (itemData) {
            getItems();
        }
    }, [itemData]);

    // useEffect(() => {
    //     if (rows.length > 0 && rows[0]?.ItemNo) {
    //         updatevat();
    //     }
    // }, [isVatExcluded]);

    useEffect(() => {

        const total = rows.reduce(
            (sum, row) => sum + Number(row?.amount || 0),
            0
        );

        const vatAmount = rows.reduce(
            (sum, row) => sum + Number(row?.vatAmount || 0),
            0
        );
        const discountAmt = (calculatedTotal * overallDiscount) / 100;
        let afterdiscount = (calculatedTotal - discountAmt)
        const grandtotals = (afterdiscount + vatAmount)
        const grandtotalsvat = (afterdiscount + vatAmount)
        let final = overallDiscount === 0 ? grandtotalsvat : grandtotals
        setDiscountAmount(discountAmt);
        setGrandTotal(final);
        setVatAmount(vatAmount)
    }, [rows, overallDiscount]);


    const updatevat = async () => {
        try {
            let vatParam = `?toPurchase=true`;
            const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
            const updatedRows = rows.map((row) => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const selectedVat = vat.data.result?.find((tax) => tax.description === row?.vatDes);
                let amount = row?.qty * row?.baseAmount;
                const perAmount = (amount / 100) * (selectedVat?.rate || 0);
                let excludedAmount = amount + perAmount;
                const calculatedAmount = excludedAmount ;
                let discountamount = row?.discount;
                let finalAmount = calculatedAmount;
                updatedRows[index].calculatedAmount = calculatedAmount?.toFixed(currencyPrecision || 3);
                updatedRows[index].amount = finalAmount?.toFixed(currencyPrecision || 3);
                updatedRows[index].vat = selectedVat?.rate || 0;
                updatedRows[index].vatDes = selectedVat?.description || 0;
                updatedRows[index].vatAmount = perAmount?.toFixed(currencyPrecision || 3);
                updatedRows[index].discountAmount = discountamount?.toFixed(currencyPrecision || 3);
                updatedRows[index].discount = row?.discount;
            });
            await Promise.all(apiPromises);
            setRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    };
    const handleQtyChange = (index, value) => {
        const newQty = Number(value || 0);
        const balQty = Number(rows[index].balQty || 0);

        if (newQty < 0) {
            toast.warning("Quantity cannot be less than 0.");
            return;
        }

        if (newQty > balQty) {
            toast.warning("Enter a quantity less than or equal to the balance quantity.");
            return;
        }

        setRows((prevRows) => {
            const newRows = [...prevRows];

            const row = { ...newRows[index] };

            const unitPrice = Number(row.baseAmount || 0);
            const vatPerc = Number(row.vat || 0);
            const convValue = Number(row.convValue || 1);

            // Overall Discount %
            const discountPerc = Number(overallDiscount || 0);

            // Qty
            row.qty = newQty;
            row.baseQty = newQty * convValue;

            // Amount
            const amount = newQty * unitPrice;

            // Discount
            const discountAmount = (amount * discountPerc) / 100;

            // After Discount
            const calculatedAmount = amount - discountAmount;

            // VAT
            const vatAmount = (calculatedAmount * vatPerc) / 100;

            // Total
            const totalAmount = calculatedAmount + vatAmount;

            row.discount = discountPerc;
            row.discountAmount = Number(
                discountAmount.toFixed(currencyPrecision)
            );

            row.calculatedAmount = Number(
                calculatedAmount.toFixed(currencyPrecision)
            );

            row.vatAmount = Number(
                vatAmount.toFixed(currencyPrecision)
            );

            row.amount = Number(
                totalAmount.toFixed(currencyPrecision)
            );

            newRows[index] = row;

            // Footer Totals
            const totalDiscount = newRows.reduce(
                (sum, item) => sum + Number(item.discountAmount || 0),
                0
            );

            const totalVat = newRows.reduce(
                (sum, item) => sum + Number(item.vatAmount || 0),
                0
            );

            const grandTotal = newRows.reduce(
                (sum, item) => sum + Number(item.amount || 0),
                0
            );

            setDiscountAmount(totalDiscount);
            setVatAmount(totalVat);
            setGrandTotal(grandTotal);

            return newRows;
        });
    };
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    };
    const handleFreeQTChange = (index, value) => {
        const newQty = value || 0;
        const balQty = rows[index].balQty;
        const qty = rows[index].qty || 0;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].freeQty = newQty;
            return newRows;
        });
    };
    const handleUnitPriceChange = (index, value) => {
        const unitPrice = value;
        const qty = rows[index].qty;
        const vatPerc = rows[index].vat;

        if (unitPrice < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }

        const amountBeforeVat = unitPrice * qty;
        const vatAmount = (amountBeforeVat * vatPerc) / 100;
        let totalAmount;

        if (selectedPOData?.costCenter5 === "excluded") {
            totalAmount = amountBeforeVat + vatAmount;
        } else {
            totalAmount = amountBeforeVat;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index].baseAmount = unitPrice;
            newRows[index].amount = totalAmount;
            newRows[index].vatAmount = vatAmount;
            return newRows;
        });
    };
    const handleBatchNo = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].batchNo = value;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, batchNo: value } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    };
    const handleVatChange = () => {
        setIsVatExcluded(!isVatExcluded);
    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-md-4">
                    <label>Discount %</label>
                    <input
                        type="number"
                        className="form-Input w-100"
                        min="0"
                        max="100"
                        value={overallDiscount} disabled
                    />
                </div>
                <div className="d-flex justify-content-between col-3">
                    <div className="form-check center mt-2">
                        <input
                            style={{ width: '26px', height: '26px' }}
                            type="checkbox"
                            className="form-check-input"
                            checked={isVatExcluded}
                            onChange={handleVatChange}
                        />
                        <label className="form-check-label mx-2 mt-1">Vat Excluded</label>
                    </div>
                </div>
            </div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Bal Qty</th>
                            <th>Free Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT Desc</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={index + 1} disabled style={{ width: "70px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "300px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'>
                                    {grnData?.eye === true ?
                                        <input
                                            className='p-2'
                                            type="number" onWheel={(e) => e.target.blur()}
                                            disabled style={{ width: "70px" }}
                                            value={row.qty}
                                        />
                                        :
                                        <input
                                            className='p-2' onWheel={(e) => e.target.blur()}
                                            type="number" style={{ width: "70px" }}
                                            value={row.qty}
                                            onKeyDown={preventNegativeSign}
                                            max={row.balQty}
                                            onChange={(e) => handleQtyChange(index, e.target.value)}
                                        />
                                    }
                                </td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty || 0} style={{ width: "130px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balQty || 0} style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' onWheel={(e) => e.target.blur()}
                                        type="number" style={{ width: "100px" }}
                                        value={row.freeQty}
                                        onKeyDown={preventNegativeSign}
                                        max={row.freeQty}
                                        onChange={(e) => handleFreeQTChange(index, e.target.value)}
                                    />
                                </td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' onWheel={(e) => e.target.blur()}
                                        type="number" style={{ width: "100px" }}
                                        value={row.baseAmount} disabled
                                    />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.discount} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatDes} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vat + "%" || 0 + "%"} disabled style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.vatAmount || 0} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.amount || 0} style={{ width: "100px" }} /></td>
                                <input
                                    className='p-2' onWheel={(e) => e.target.blur()}
                                    type="number" style={{ width: "120px" }}
                                    value={row.batchNo}
                                    onKeyDown={preventNegativeSign}
                                    onChange={(e) => handleBatchNo(index, e.target.value)}
                                />
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} disabled={grnData?.eye === true ? true : false}
                                    onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">_</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">After Discount</div>
                    <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">+</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
                <div>
                    <div className="totalhead center">=</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default UpdateItemGridGRN;